import { QueryClient } from "@tanstack/react-query";

/**
 * Клиент запросов приложения.
 *
 * Чтение без сети TanStack Query приостанавливает и возобновляет сам, когда
 * связь возвращается, — это нужное поведение. С записью иначе: по умолчанию
 * изменение без сети «замораживается» и уходит на сервер позже, когда человек
 * уже ушёл с экрана, а форма всё это время показывает вечное «Сохраняем…».
 * ERP не умеет принимать изменения офлайн, поэтому запись без сети должна
 * завершиться ошибкой сразу, с понятным сообщением, а введённое — остаться в
 * форме.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: { mutations: { networkMode: "always" } },
  });
}
